<template>
<div class="control">
    <input class="input" :name="config.name ? config.name : config.label" :required="config.required" :type="config.type" :placeholder="(config.placeholder ? config.placeholder : config.label) + (config.required ? ' (*)' : '')" />
</div>
</template>

<script>
export default {
    name    :   'Input',
    props   :   ['config']
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/formfields/Input.vue